import { LogoCarousel } from './LogoCarousel'
import apiService from 'services/api'

export function Logo() {
  const api = apiService()
  const { data: companyData, isLoading } = api.useGetCompanyDetails()

  return (
    <div className="flex flex-col w-full">
      {isLoading ? (
        <div className="text-center text-gray-600 py-6">
          Loading logo information...
        </div>
      ) : (
        <>
          <h3 className="text-lg font-semibold text-gray-600">Company Logo</h3>
          <span className="text-sm text-gray-600 mt-2">
            {companyData?.logos && companyData.logos.length > 0 ? (
              <>
                Change or remove your company logo below.
                <br /> Accepted file types are JPG, JPEG, PNG, and SVG. <br />
                Max file size is 2MB.
              </>
            ) : (
              <>
                Add your company logo below. Accepted file types <br /> are JPG,
                JPEG, PNG, and SVG. Max file size is 2MB.
              </>
            )}
          </span>

          <div className="mt-6">
            <LogoCarousel logos={companyData?.logos} />
          </div>
        </>
      )}
    </div>
  )
}
